module.exports = __webpack_public_path__ + "assets/ellipse.e6427626.svg";